import React from 'react';
import Helmet from 'react-helmet';
import { GlobalStyles, styled } from 'twin.macro';

import { useAcceptCookies } from '../hooks/useAcceptCookies';
import config from '../utils/config';
import Header from './global/Header';
import Footer from './global/Footer';
import Cookie from './global/Cookie';
import StylesBase from '../utils/styles';
// import ThemeToggle from './ThemeToggle';

const Container = styled.div`
  min-height: 70vh;
`;

const IndexLayout = ({ children, hideHeader, ...rest }) => {
  const { acceptedCookies, onAcceptCookies } = useAcceptCookies();

  return (
    <>
      <Helmet>
        <title>{config.siteName}</title>
        <meta description={config.description} />
      </Helmet>
      <div {...rest}>
        <GlobalStyles />
      </div>
      <StylesBase />
      {!hideHeader && <Header />}
      <Container>{children}</Container>
      <Footer />
      <Cookie hide={acceptedCookies} onClick={() => onAcceptCookies()} />
    </>
  );
};

export default IndexLayout;
